window.CarouselAPI = window?.CarouselAPI || {};

/**
 * Helper method to get localized data
 * @param {*} key
 * @returns
 */
window.CarouselAPI.Utils = {
  getLocalized(key) {
    const localized = window?.carousel_data ?? null;

    if (localized[key] !== undefined) {
      return localized[key];
    }

    return null;
  },
  animationClass: "animate-in",
};
